import React from 'react'
import { LinearProgress, Box, Typography } from '@mui/material';

export const PercentageBarLabel = ({ percentage, altura, color='parrafoPrimary' }) => {

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', overflow: "hidden" }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress sx={{height: altura, borderRadius: "0.3em"}} variant="determinate" value={percentage} />
                </Box>
                <Box sx={{ minWidth: 45 }}>
                    <Typography variant={color} fontWeight={'bold'}>{percentage}%</Typography>
                </Box>
            </Box>
        </>
    )
}
